<div class="card-wrapper">
  <div class="header">
    <ion-icon class="image" [name]="iconName"> </ion-icon>
    <span>{{ header }}</span>
  </div>
  <ng-content></ng-content>
</div>
